import { FC } from "react";
import { Paper, Box, Typography } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { RxBasicInfoDto } from "../../../../../../../api-client";
import TransactionRxOverview from "../../TransactionRxOverview";

interface RxDetailViewProps {
  rx: RxBasicInfoDto;
}

export const RxDetailView: FC<RxDetailViewProps> = ({ rx }) => {
  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
        borderRadius: 2,
        bgcolor: "#D9DFE2",
        border: "1px solid #e0e0e0",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 1,
          bgcolor: "white",
          color: "black",
          display: "flex",
          alignItems: "center",
          gap: 1,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <ReceiptIcon fontSize="small" sx={{ color: "#757575" }} />
        <Typography variant="body2" fontWeight="500">
          Rezept Details
        </Typography>
      </Box>

      {/* Content */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          p: 1,
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f5f5f5",
            borderRadius: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#bdbdbd",
            borderRadius: "6px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#9e9e9e",
          },
        }}
      >
        <TransactionRxOverview
          rowData={rx}
          masterData={null}
          editRxMode={false}
          setEditRxMode={() => {}}
        />
      </Box>
    </Paper>
  );
};
